import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { NgbDropdownModule, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { Backend } from 'src/app/backend-interface/backend';
import { LoadingErrorComponent } from 'src/app/components/loading-error/loading-error.component';
import { Client, RefPolicy, RequestRefPolicy } from 'src/app/service/global.service';
import { TranslationService } from 'src/app/service/translation.service';

@Component({
  selector: 'app-form-ref-policies-settings',
  templateUrl: './form-ref-policies-settings.component.html',
  styleUrls: ['./form-ref-policies-settings.component.scss'],
  standalone: true,
  imports: [
    TranslateModule,
    CommonModule,
    ReactiveFormsModule,
    LoadingErrorComponent,
    NgbDropdownModule
  ],
  providers: [NgbModal, TranslationService]
})
export class FormRefPoliciesSettingsComponent {
  @Input({ required: false }) action?: string;
  @Input({ required: false }) refPolicy?: RefPolicy;
  @Input({ required: false }) client?: Client;

  @Output() addRefPolicy = new EventEmitter<RequestRefPolicy>();
  @Output() patchRefPolicy = new EventEmitter<RequestRefPolicy>();
  @Output() deleteRefPolicy = new EventEmitter<RefPolicy>();

  form?: FormGroup;
  lClient: Client[] = [];

  constructor(private readonly modalService: NgbModal) {}

  async open({ content }: { content: any }) {
    this.modalService.open(content, { centered: true });
    switch (this.action) {
      case 'add-client-ref':
        this.lClient = await Backend.POLICIES.getClients();
        if (this.lClient.length > 0) {
          this.form = new FormGroup({
            name: new FormControl('', [Validators.required, Backend.SETTINGS.noWhitespaceValidator()]),
            clientId: new FormControl(this.client?.id ?? this.lClient[0].id, Validators.required)
          });
        }
        break;
      case 'add-default-ref':
        this.form = new FormGroup({
          name: new FormControl('', [Validators.required, Backend.SETTINGS.noWhitespaceValidator()])
        });
        break;
      case 'edit-client-ref':
      case 'edit-default-ref':
        if (this.refPolicy) {
          this.form = new FormGroup({
            name: new FormControl(this.refPolicy.name, [Validators.required, Backend.SETTINGS.noWhitespaceValidator()])
          });
        }
        break;
    }
  }

  getFormControl(champ: string): FormControl {
    return this.form?.get(champ) as FormControl;
  }

  findClient(): Client | undefined {
    return this.lClient.find((client: Client) => client.id === this.getFormControl('clientId')?.value);
  }

  setClient(id: number | undefined) {
    this.form?.patchValue({ clientId: id });
  }

  formDisabled(): boolean {
    return !this.form || Object.keys(this.form.controls).length === 0;
  }

  emitPatchRefPolicy() {
    if (!this.form || !this.refPolicy) return;
    const name = this.getFormControl('name').value;
    switch (this.action) {
      case 'edit-client-ref':
        this.patchRefPolicy.emit({id: this.refPolicy.id, name, type: this.refPolicy.type, clientId: this.refPolicy.client?.id});
        break;
      case 'edit-default-ref':
        this.patchRefPolicy.emit({id: this.refPolicy.id, name, type: this.refPolicy.type});
        break;
    }
  }

  emitAddRefPolicy() {
    if (!this.form) return;
    const name = this.getFormControl('name').value;
    switch (this.action) {
      case 'add-client-ref':
        this.addRefPolicy.emit({name, type: 'client', clientId: this.getFormControl('clientId').value});
        break;
      case 'add-default-ref':
        this.addRefPolicy.emit({name, type: 'default'});
        break;
    }
  }

  emitDeleteRefPolicy() {
    if (this.refPolicy) {
      this.deleteRefPolicy.emit(this.refPolicy);
    }
  }
}
